import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({
  backgroundColor,
  iconColor,
  label,
  onClick,
  icon,
  fontSize,
  boxShadow,
  buttonStyle,
  buttonTextStyle,
  border,
  borderColor,
  size,
  disabled,
  isBackgroundImage
}) => {
  return (
    <div
      role="presentation"
      className={`icon-button ${disabled && 'icon-button_disabled'}`}
      onClick={onClick}
    >
      <div
        className={`icon-button_btn ${border &&
          'icon-button_btn-border'} ${size === 'small' &&
          'icon-button_btn-small'}`}
        type="button"
        style={{
          backgroundColor,
          boxShadow: boxShadow ? 'rgba(0,0,0,0.25)' : 'unset',
          width: !icon && 14,
          height: !icon && 14,
          borderColor: border && borderColor,
          ...buttonStyle
        }}
      >
        <div
          className={`icon-button_icon ${size === 'small' &&
            'icon-button_icon-small'}`}
          style={{
            backgroundColor: iconColor,
            WebkitMaskImage: `url(${icon})`,
            maskImage: `url(${icon})`,
            backgroundImage: isBackgroundImage ? `url(${icon})` : 'unset'
          }}
        />
      </div>
      {label && (
        <p
          className={`icon-button_text ${size === 'small' &&
            'icon-button_text-small'}`}
          style={{ fontSize, ...buttonTextStyle }}
        >
          {label}
        </p>
      )}
    </div>
  );
};

IconButton.propTypes = {
  icon: PropTypes.node,
  buttonStyle: PropTypes.object,
  buttonTextStyle: PropTypes.object,
  label: PropTypes.string,
  border: PropTypes.bool,
  disabled: PropTypes.bool,
  boxShadow: PropTypes.string,
  fontSize: PropTypes.string,
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string,
  borderColor: PropTypes.string,
  isBackgroundImage: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'large'])
};

export default IconButton;
